import { Pipe, PipeTransform } from '@angular/core';
import { AccountGroupLocation, AccountGroupService, ProjectionFilter } from '@galaxy/account-group';
import { map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'getAccountInfo',
})
export class GetAccountInfoPipe implements PipeTransform {
  #accountInfoCache: Map<string, AccountGroupLocation> = new Map();

  constructor(private accountGroupService: AccountGroupService) {}

  transform(accountGroupId?: string): Observable<AccountGroupLocation> {
    if (!accountGroupId) {
      return of(null);
    }
    const accountGroupFromCache: AccountGroupLocation = this.#accountInfoCache.get(accountGroupId);
    if (accountGroupFromCache) {
      return of(accountGroupFromCache);
    }
    return this.accountGroupService.get(accountGroupId, new ProjectionFilter({ napData: true })).pipe(
      map((accountGroup) => accountGroup?.napData),
      tap((accountInfo) => this.#accountInfoCache.set(accountGroupId, accountInfo)),
    );
  }
}
